class QuickAddBottomSheet extends HTMLElement {
  constructor() {
    super();

    // Bind methods
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.popupMobile = this.dataset.popup == "mobile";
    this.addToBagBtn = this.querySelector('button.js-add-to-cart-btn')
    this.selectVariantBtn = this.querySelector('button[type="button"][js-bottom-sheet-trigger]')
    this.variants = this.querySelectorAll('[js-variant-color]');
    this.boundToCartForm = this.boundToCartForm.bind(this);
    this.radioInputs = this.querySelectorAll('input[type="radio"][name="id"]');
    this.triggers = this.querySelectorAll('[js-bottom-sheet-trigger]');
    this.backdrop = this.querySelector('[js-bottom-sheet-backdrop]');
    this.sheet = this.querySelector('[js-bottom-sheet]');
    this.optionColors = this.querySelectorAll('[js-variant-color]');
    this.colorTextElement = this.querySelector('[js-variant-color-text]');
    this.variantTextTitle = this.querySelector('[js-variant-text-title]');
    this.dragTrigger = this.querySelector('[js-drag-bar]');
    this.closeButton = this.querySelector('[js-bottom-close-button]');
    this.variantParent = this.closest('[js-variants-parent]')
    this.variantImages = this.variantParent?.previousElementSibling.querySelectorAll('[js-product-featured-image')
    this.formSubmitButton = this.querySelector('[js-form-submit-btn]')
    this.closeButton = this.querySelector('[js-close-btn]');
    this.addToCartBtn = this.querySelector('[js-variant-add-to-bag]');
    this.cart = document.querySelector('#cart-drawer');
    this.modalVariantPickerMob = null
    this.selector = ''
    this.getSectionsToRender = this.getSectionsToRender.bind(this);

    // Initialize properties
    this.cartForm = null;
  }

  connectedCallback() {
    this.selectVariant();
    this.radioSelect();
    this.updateOptionColors();
    this.openSelectVariantModal();
    this.openBackDrop()
    this.draggableFunction();
    this.handleToggleSellingPlan();

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close);
    }

    if (this.addToCartBtn) {
      this.addToCartBtn.addEventListener('click', () => {
        this.close();
        Cart.openCartDrawer();
      });
    }

    if (this.addToBagBtn && this.addToBagBtn.dataset.selector) {
      this.addToBagBtn.addEventListener('click', () => {
        const buttonMain = document.querySelector(`[data-selector-main="${this.addToBagBtn.dataset.selector}"]`);
        buttonMain?.click();
      });
    }
  }

  draggableFunction() {
    if (!this.dragTrigger) return;

    let initialY = 0;
    let currentY = 0;
    this.dragTrigger.addEventListener('touchstart', (e) => {
      initialY = e.changedTouches[0].screenY;
      this.sheet.style.transition = 'none';
    });
    this.dragTrigger.addEventListener('touchmove', (e) => {
      currentY = e.changedTouches[0].screenY - initialY;
      this.sheet.style.bottom = `-${currentY}px`;
    });
    this.dragTrigger.addEventListener('touchend', () => {
      this.sheet.style.removeProperty('bottom');
      if (currentY > 100) {
        this.close();
      } else {
        this.open();
      }

      initialY = 0;
      currentY = 0;
      this.sheet.style.transition = 'all 0.3s';
    });
  }
  
  openBackDrop() {
    if (!this.backdrop) return
    this.backdrop.addEventListener('click', (e) => {
      e.stopPropagation();
      this.close();
    });
  }

  openSelectVariantModal() {
    if (!this.triggers) return
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        this.selector = trigger.dataset.selector;
        this.modalVariantPickerMob = document.querySelectorAll(`.js-sticky-modal[data-selector="${this.selector}"]`)

        if (!this.modalVariantPickerMob) return
        this.modalVariantPickerMob.forEach(modal => {
          modal.classList.add('open')
        });
        this.open();
        // this.selectVariant();

      });
    })
  }

  updateOptionColors() {
    if (this.radioInputs.length === 1) {
      this.radioInputs[0].checked = true;
    }

    this.radioInputs.forEach((radio, radioIndex) => {
      if (radio.checked) {
        const form = radio.closest('form');
        form.querySelectorAll('input[name="id"][type="hidden"]').forEach((input) => {
          input.value = radio.value;
        })

        let colorTextHasValue = false;
        this.optionColors.forEach((color, colorIndex) => {
          if (radioIndex == colorIndex) {
            color.classList.remove('hidden');
            this.colorTextElement.innerText = color.dataset.color;
            this.colorTextElement.classList.remove('hidden');
            colorTextHasValue = true;
          } else {
            color.classList.add('hidden');
          }
        });

        if (!colorTextHasValue && this.colorTextElement) {
          this.colorTextElement.classList.remove('hidden');
          this.colorTextElement.innerText = radio.dataset.variantTitle;
          if (this.variantTextTitle) this.variantTextTitle?.classList.add('hidden');
        }
        // this.selectVariant();
      }
    });
  }

  updateOptionColorsFromClone(selector) {
    const triggers = document.querySelectorAll(`.js-variant-options[data-selector="${selector}"]`)
    triggers.forEach(trigger => {
      if (this.radioInputs.length === 1) {
        this.radioInputs[0].checked = true;
      }

      this.radioInputs.forEach((radio, radioIndex) => {
        if (radio.checked) {
          const form = trigger.closest('form');
          form.querySelectorAll('input[name="id"][type="hidden"]').forEach((input) => {
            input.value = radio.value;
          })

          let colorTextHasValue = false;
          const optionColors = trigger.querySelectorAll('[js-variant-color]');
          const colorTextElement = trigger.querySelector('[js-variant-color-text]');
          optionColors.forEach((color, colorIndex) => {
            if (radioIndex == colorIndex) {
              color.classList.remove('hidden');
              colorTextElement.innerText = color.dataset.color;
              colorTextElement.classList.remove('hidden');
              colorTextHasValue = true;
            } else {
              color.classList.add('hidden');
            }
          });

          if (!colorTextHasValue && colorTextElement) {
            colorTextElement.classList.remove('hidden');
            colorTextElement.innerText = radio.dataset.variantTitle;
            if (this.variantTextTitle) this.variantTextTitle?.classList.add('hidden');
          }
          // this.selectVariant();
        }
      });
    });
  }

  radioSelect() {
    this.radioInputs.forEach((radio, radioIndex) => {
      radio.addEventListener('change', (e) => {
        const selector = radio.dataset.selector;
        this.updateOptionColors();
        this.updateOptionColorsFromClone(selector);
        this.updateVariantMedia(radio);
      });

      radio.addEventListener('click', (e) => {
        if (this.addToBagBtn) {
          this.addToBagBtn.dataset.willBeClicked = true;
        }
        this.radioInputs.forEach((radio, radioIndex) => {
          if (radio.checked) {
            radio.dispatchEvent(new Event('change'));
          }
        });
        this.selectVariant();
      });
    });
  }

  selectVariant() {

    // const productInfo = this.closest('product-info');
    // if(productInfo) {
    //   // if this quick-add-bottom is in product-info, then the variant-picker.js will handle click event
    //   this.close();
    //   return;
    // }
    if (this.addToBagBtn && this.addToBagBtn.dataset.willBeClicked) {
      if (!this.popupMobile) {
        this.addToBagBtn.click();
        this.addToBagBtn.dataset.willBeClicked = false;
        this.close();
      }
    }
  }

  updateVariantMedia(input) {
    if (!this.variantImages) return;

    if (this.variantImages.length > 1) {
      this.variantImages.forEach((image, index) => {
        if (index === 1) {
          image.src = input.dataset.image
        }
      })
    } else {
      this.variantImages[0].src = input.dataset.image
    }
  }

  handleToggleSellingPlan() {
    const toggleInput = this.querySelectorAll('[js-variant-selling-plan-toggle]');
    if (!toggleInput) return;
    toggleInput.forEach((input) => {

      input.addEventListener('click', () => {
        this.handleUpdateValues(input);
      })
    });
  }

  handleUpdateValues(input) {
    const selectorId = input.dataset.selectorId,
      sellingPlanId = this.querySelector(`.js-variant-selling-plan--${selectorId}`),
      sellingPlanValue = input.checked ? sellingPlanId?.value : '',
      productHandle = sellingPlanId.dataset.productHandle,
      variantId = selectorId.includes('-') ? selectorId.split('-')[1] : selectorId;
    clearTimeout(this.timeOutUpdateValue);
    this.timeOutUpdateValue = setTimeout(() => {
      this.updateValues(variantId, sellingPlanValue, productHandle);
    }, 100);
  }

  updateValues(variantId, sellingPlan, handle) {
    if (!variantId) return;
    this.updateFromRenderApi(variantId, sellingPlan, handle);

    if (this.cartForm?.form?.querySelectorAll('[name="id"]')) {
      this.cartForm.form.querySelectorAll('[name="id"]').forEach((input) => {
        input.value = variantId;
      });
    }

    const sellingPlanInputs = this.querySelectorAll('input[js-variant-selling-plan]')
    sellingPlanInputs.forEach(input => {
      if (input.value == sellingPlan) {
        input.click();
      }
    });
  }

  async updateFromRenderApi(variantId, sellingPlan, handle) {
    try {
      this.setLoadingState(true);
      const res = await fetch(
        `${window.routes.root}products/${handle}?variant=${variantId}&selling_plan=${sellingPlan}`
      ).then((res) => res.text());
      const html = new DOMParser().parseFromString(res, 'text/html');
      const sections = this.getSectionsToRender();

      sections.forEach(section => {
        const sectionElement = section.id != '' ? html.getElementById(section.id) : html.querySelector(section.customSelector);
        this.updatePrice(sectionElement);
      });

    } catch (error) {
      console.error(error);
    } finally {
      this.setLoadingState(false);
      this.close();
    }
  }

  updatePrice(element) {
    const scopes = ['.js-price-last', '.js-price-regular', '.js-price-sale-percent']
    scopes.forEach(scope => {

      const scopeValue = element.querySelector(`${scope}`);
      const valuesToReplace = this.querySelectorAll(`${scope}`);
      valuesToReplace.forEach((value) => {
        if (scope == '.js-price-sale-percent') {
          value.innerHTML = scopeValue.innerHTML;
        } else {
          value.innerHTML = scopeValue.innerHTML.match(/[$£€¥]\d+(\.\d{2})?/)[0];
        }
      });
    });

  }

  getSectionsToRender() {
    return [
      {
        id: ``,
        customSelector: 'product-info',
        target: 'price',
        outer: true,
      }
    ];
  }

  updateAvailability(variant) {
    this.querySelectorAll('[js-variant-add-to-bag]').forEach((button) => {
      button.disabled = !variant.available;
      button.querySelector('div:first-child').innerText = variant.available ? 'Add to bag' : 'Sold out';
    });
  }

  open() {
    this.classList.add('open');
    // this.sheet.style.bottom = 0;
    if (this.sheet) {
      if (!this.sheet.dataset.bodyLock) {
        document.body.classList.add('overflow-hidden');
      }
    }

    if (this.modalVariantPickerMob) {
      this.modalVariantPickerMob.forEach(modal => {
        modal.classList.add('open')
      });
    }
    this.cartForm?.addEventListener('cart-form-submit', this.close);
    window.toggleChatBox(false);
  }

  close() {
    if (!this.classList.contains('open')) return;

    // Hide modal in mobile too
    const modalVariantOpened = document.querySelectorAll('.js-sticky-modal.open')
    if (modalVariantOpened) {
      modalVariantOpened.forEach(modal => {
        modal.classList.remove('open')
      });
    }

    this.classList.add('closing');
    setTimeout(() => {
      this.classList.remove('open');
      this.classList.remove('closing');
      // this.sheet.style.bottom = `-100%`;

      if (!this.cart.classList.contains('active')) {
        document.body.classList.remove('overflow-hidden');
      }
    }, 300);
    this.cartForm?.removeEventListener('cart-form-submit', this.close);
    window.toggleChatBox(true);
  }

  setLoadingState(isLoading) {
    const variantOptionsBar = this.querySelectorAll('.js-variant-option')

    if (isLoading) {
      variantOptionsBar.forEach(bar => {
        bar.classList.add('loading');
      });
    } else {
      variantOptionsBar.forEach(bar => {
        bar.classList.remove('loading');
      });
    }
  }

  boundToCartForm(cartForm) {
    this.cartForm = cartForm;
  }
}

if (!customElements.get('quick-add-bottom-sheet')) {
  customElements.define('quick-add-bottom-sheet', QuickAddBottomSheet);
}